import { Hook, makeHook } from './Hook'
import * as WebRecorder2PubSub from '../webRecorder2/pubSub'

class DropZoneHook extends Hook {
  mounted() {
    WebRecorder2PubSub.subscribe('recording-started', () => {
      this.el.classList.add('hidden')
    })

    WebRecorder2PubSub.subscribe('recording-scheduled', () => {
      this.el.classList.add('hidden')
    })

    WebRecorder2PubSub.subscribe('recording-cleared', () => {
      this.el.classList.remove('hidden')
    })

    this.el.addEventListener('dragover', (e: DragEvent) => {
      e.preventDefault()
      this.el.classList.add('bg-info', 'border-info')
    })

    this.el.addEventListener('dragleave', (_e: DragEvent) => {
      this.el.classList.remove('bg-info', 'border-info')
    })

    this.el.addEventListener('drop', (e: DragEvent) => {
      e.preventDefault()
      this.el.classList.remove('bg-info', 'border-info')
      // Handle the file drop event here
    })
  }
}

export default makeHook(DropZoneHook)
